module.exports = __webpack_public_path__ + "img/check_4.94aa7aee.png";